<template>
  <v-text-field
      :value="text"
      inputmode="decimal"
      :placeholder="required ? 'required' : 'none'"
      :suffix="unit"
      :disabled="disabled"
      :error="required && normaliseValue(text) === null"
      dense
      hide-details
      @input="onInput"
      @blur="onBlur"
  />
</template>

<script>
import {normaliseValue, sanitiseNumberText} from '@/utils/nutrient-targets';

// a plain text box that only accepts a number (or nothing): no spinner arrows
export default {
  name: 'NutrientTargetField',
  props: {
    value: {type: [Number, String], default: null, required: false},
    unit: {type: String, default: '', required: false},
    required: {type: Boolean, default: false, required: false},
    disabled: {type: Boolean, default: false, required: false},
  },
  data() {
    return {text: this.asText(this.value)};
  },
  watch: {
    value(value) {
      // leave "12." alone mid-typing: only resync when the number itself changed
      if (normaliseValue(value) !== normaliseValue(this.text)) {
        this.text = this.asText(value);
      }
    },
  },
  methods: {
    normaliseValue,
    asText(value) {
      const number = normaliseValue(value);
      return number === null ? '' : String(number);
    },
    onInput(typed) {
      const clean = sanitiseNumberText(typed);
      if (clean !== typed) {
        // show the rejected keystroke for a tick, then snap back so the box re-renders clean
        this.text = typed;
        this.$nextTick(() => this.text = clean);
      } else {
        this.text = clean;
      }
      this.$emit('input', clean);
    },
    onBlur() {
      // tidy up "12." or "007" once the user is done typing
      this.text = this.asText(this.text);
      this.$emit('input', this.text);
    },
  },
};
</script>
